export interface CommunityInfo {
    name: string;
    displayName: string;
    shortName: string;
    domain: string;
    features: {
        inns: boolean;
        priests: boolean;
        // Add more features as needed
        // Admin access is automatically granted when feature is enabled
    };
    firebase: {
        apiKey?: string;
        authDomain?: string;
        projectId?: string;
        storageBucket?: string;
        messagingSenderId?: string;
        appId?: string;
        measurementId?: string;
    };
}

export const COMMUNITY_CONFIG: CommunityInfo[] = [
    {
        name: 'paliwal',
        displayName: 'पालीवाल समाज',
        shortName: 'Paliwal',
        domain: 'paliwalsamajweb.in',
        features: {
            inns: true,
            priests: true
        },
        firebase: {
            apiKey: "AIzaSyBt4AFa-EZ1_QBOvvh_VZQB_jwcKqfJAH8",
            authDomain: "paliwal-community-data.firebaseapp.com",
            projectId: "paliwal-community-data",
            storageBucket: "paliwal-community-data.firebasestorage.app",
            messagingSenderId: "763889938440",
            appId: "1:763889938440:web:e8296a5e42eb50e51561bd",
            measurementId: "G-XHLFK2TW9N"
        }
    },
    {
        name: 'meghwal',
        displayName: 'मेघवाल समाज',
        shortName: 'Meghwal',
        domain: 'meghwalsamajweb.in',
        features: {
            inns: false,
            priests: false
        },
        firebase: {
            // apiKey: "AIzaSyBt4AFa-EZ1_QBOvvh_VZQB_jwcKqfJAH8",
            // authDomain: "paliwal-community-data.firebaseapp.com",
            // projectId: "paliwal-community-data",
            // storageBucket: "paliwal-community-data.firebasestorage.app",
            // messagingSenderId: "763889938440",
            // appId: "1:763889938440:web:e8296a5e42eb50e51561bd",
            // measurementId: "G-XHLFK2TW9N"
        }
    }
];

// Function to get current community info based on domain
export const getCurrentCommunity = (): CommunityInfo => {
    if (typeof window === 'undefined') return COMMUNITY_CONFIG[0];
    const currentDomain = window.location.hostname;

    // For localhost, default to Meghwal community (as per user's preference)
    if (currentDomain === 'localhost' || currentDomain === '127.0.0.1') {
        return COMMUNITY_CONFIG.find(config => config.name === 'paliwal') || COMMUNITY_CONFIG[0];
    }

    // Find matching community config for production domains
    const community = COMMUNITY_CONFIG.find(config =>
        currentDomain === config.domain ||
        currentDomain.includes(config.domain)
    );

    // Return first community as fallback if no match found
    return community || COMMUNITY_CONFIG[0];
};

// Function to get community-specific text
export const getCommunityText = (key: string): string => {
    const community = getCurrentCommunity();

    const textMap: Record<string, Record<string, string>> = {
        'paliwal': {
            'communityInns': 'धर्मशालाएँ – Paliwal Samaj',
            'addInn': 'नई धर्मशाला जोड़ें',
            'editInn': 'धर्मशाला संपादित करें',
            'submitInn': 'धर्मशाला जमा करें',
            'updateInn': 'धर्मशाला अपडेट करें',
            'innName': 'धर्मशाला का नाम',
            'innNamePlaceholder': 'धर्मशाला का नाम दर्ज करें',
            'contactNumber': 'संपर्क नंबर',
            'contactNumberPlaceholder': 'संपर्क नंबर दर्ज करें (वैकल्पिक)',
            'location': 'स्थान',
            'fullAddress': 'पूरा पता',
            'fullAddressPlaceholder': 'पूरा पता दर्ज करें (वैकल्पिक)',
            'city': 'शहर',
            'cityPlaceholder': 'शहर दर्ज करें (वैकल्पिक)',
            'state': 'राज्य',
            'statePlaceholder': 'राज्य दर्ज करें (वैकल्पिक)',
            'googleMapsLink': 'Google Map लिंक',
            'googleMapsLinkPlaceholder': 'Google Map लिंक दर्ज करें (वैकल्पिक)',
            'managementCommittee': 'प्रबंधन समिति',
            'memberName': 'सदस्य का नाम',
            'memberNamePlaceholder': 'सदस्य का नाम दर्ज करें (वैकल्पिक)',
            'memberContact': 'संपर्क नंबर',
            'memberContactPlaceholder': 'संपर्क नंबर दर्ज करें (वैकल्पिक)',
            'caretaker': 'केयरटेकर',
            'caretakerName': 'केयरटेकर का नाम',
            'caretakerNamePlaceholder': 'केयरटेकर का नाम दर्ज करें (वैकल्पिक)',
            'caretakerContact': 'केयरटेकर का नंबर',
            'caretakerContactPlaceholder': 'संपर्क नंबर दर्ज करें (वैकल्पिक)',
            'details': 'विवरण',
            'history': 'इतिहास',
            'historyPlaceholder': 'यह धर्मशाला किसने और कब बनवाई? (वैकल्पिक)',
            'images': 'तस्वीरें',
            'additionalInfo': 'अतिरिक्त जानकारी',
            'underPaliwalSamaj': 'क्या यह पालीवाल समाज के अधीन है?',
            'underDispute': 'क्या इसमें कोई विवाद है?',
            'disputeDetails': 'विवाद का विवरण',
            'disputeDetailsPlaceholder': 'विवाद का विवरण दर्ज करें',
            'submitterInfo': 'आपकी जानकारी',
            'fullName': 'पूरा नाम',
            'fullNamePlaceholder': 'अपना पूरा नाम दर्ज करें',
            'mobile': 'मोबाइल नंबर',
            'mobilePlaceholder': 'अपना मोबाइल नंबर दर्ज करें',
            'relationship': 'धर्मशाला से संबंध',
            'relationshipPlaceholder': 'अपना संबंध दर्ज करें (वैकल्पिक)',
            'statusUpdate': 'स्थिति अपडेट करें',
            'currentStatus': 'वर्तमान स्थिति',
            'newStatus': 'नई स्थिति चुनें',
            'pending': '⏳ लंबित (Pending)',
            'active': '✅ सक्रिय (Active)',
            'rejected': '❌ अस्वीकृत (Rejected)',
            'undefined': '❓ अपरिभाषित (Undefined)',
            'submitting': 'जमा हो रहा है...',
            'cancel': 'Cancel',
            'deleteConfirmation': 'Delete Confirmation',
            'areYouSure': 'Are you absolutely sure?',
            'deleteWarning': 'This action cannot be undone. This will permanently delete the dharamshala profile',
            'confirmDelete': 'Confirm delete dharamshala',
            'deleting': 'Deleting dharamshala',
            'noInnsFound': 'No inns found',
            'noInnsMessage': 'No inns have been added yet.',
            'addFirstInn': 'Add First Inn',
            'loadMoreInns': 'Load More Inns',
            // Priest-specific text
            'priestSamaj': 'पालीवाल ब्राह्मण समाज',
            'priestList': 'आचार्य गणों की सूची',
            'searchPriests': 'आचार्यों की सूची खोजें',
            'searchAndFilter': 'खोज और फ़िल्टर करें',
            'searchDescription': 'आचार्यों को नाम या कार्य पद्धति से खोजें',
            'searchByName': 'नाम से खोजें...',
            'searchByNameAria': 'नाम से आचार्य खोजें',
            'filterByWorkMethod': 'कार्य पद्धति से फिल्टर करें',
            'allWorkMethods': 'सभी कार्य पद्धति',
            'filterByStatus': 'Filter by status',
            'allStatuses': 'All Statuses',
            'searchButton': 'खोजें',
            'priestsFound': 'आचार्य मिले',
            'noPriestsAdded': 'अभी तक कोई आचार्य नहीं जोड़े गए हैं।',
            'noPriestsMatchFilter': 'कोई आचार्य वर्तमान एडमिन फ़िल्टर से मेल नहीं खाता।',
            'noApprovedPriests': 'अभी तक कोई स्वीकृत आचार्य उपलब्ध नहीं है।',
            'updatePriestInfo': 'आचार्य की जानकारी अपडेट करें',
            'newPriestInfo': 'नए आचार्य की जानकारी',
            'priestPhoto': 'आचार्य की फोटो',
            'priestName': 'आचार्य का नाम',
            'priestNamePlaceholder': 'आचार्य का नाम दर्ज करें',
            'fatherName': 'आचार्य के पिता का नाम',
            'fatherNamePlaceholder': 'आचार्य के पिता का नाम दर्ज करें',
            'addPriest': 'आचार्य जोड़ें',
            'priestAddedSuccess': 'नए आचार्य को सफलतापूर्वक जोड़ दिया गया है।',
            'requestSubmitted': 'अनुरोध सबमिट किया गया',
            'requestSubmittedDesc': 'आपका अनुरोध सफलतापूर्वक सबमिट कर दिया गया है, एडमिन शीघ्र ही इसकी समीक्षा करेंगे',
            'okay': 'ठीक है',
            'successfullyAdded': 'सफलतापूर्वक जोड़ा गया!'
        },
        'meghwal': {
            'communityInns': 'धर्मशालाएँ – Meghwal Samaj',
            'addInn': 'नई धर्मशाला जोड़ें',
            'editInn': 'धर्मशाला संपादित करें',
            'submitInn': 'धर्मशाला जमा करें',
            'updateInn': 'धर्मशाला अपडेट करें',
            'innName': 'धर्मशाला का नाम',
            'innNamePlaceholder': 'धर्मशाला का नाम दर्ज करें',
            'contactNumber': 'संपर्क नंबर',
            'contactNumberPlaceholder': 'संपर्क नंबर दर्ज करें (वैकल्पिक)',
            'location': 'स्थान',
            'fullAddress': 'पूरा पता',
            'fullAddressPlaceholder': 'पूरा पता दर्ज करें (वैकल्पिक)',
            'city': 'शहर',
            'cityPlaceholder': 'शहर दर्ज करें (वैकल्पिक)',
            'state': 'राज्य',
            'statePlaceholder': 'राज्य दर्ज करें (वैकल्पिक)',
            'googleMapsLink': 'Google Map लिंक',
            'googleMapsLinkPlaceholder': 'Google Map लिंक दर्ज करें (वैकल्पिक)',
            'managementCommittee': 'प्रबंधन समिति',
            'memberName': 'सदस्य का नाम',
            'memberNamePlaceholder': 'सदस्य का नाम दर्ज करें (वैकल्पिक)',
            'memberContact': 'संपर्क नंबर',
            'memberContactPlaceholder': 'संपर्क नंबर दर्ज करें (वैकल्पिक)',
            'caretaker': 'केयरटेकर',
            'caretakerName': 'केयरटेकर का नाम',
            'caretakerNamePlaceholder': 'केयरटेकर का नाम दर्ज करें (वैकल्पिक)',
            'caretakerContact': 'केयरटेकर का नंबर',
            'caretakerContactPlaceholder': 'संपर्क नंबर दर्ज करें (वैकल्पिक)',
            'details': 'विवरण',
            'history': 'इतिहास',
            'historyPlaceholder': 'यह धर्मशाला किसने और कब बनवाई? (वैकल्पिक)',
            'images': 'तस्वीरें',
            'additionalInfo': 'अतिरिक्त जानकारी',
            'underPaliwalSamaj': 'क्या यह मेघवाल समाज के अधीन है?',
            'underDispute': 'क्या इसमें कोई विवाद है?',
            'disputeDetails': 'विवाद का विवरण',
            'disputeDetailsPlaceholder': 'विवाद का विवरण दर्ज करें',
            'submitterInfo': 'आपकी जानकारी',
            'fullName': 'पूरा नाम',
            'fullNamePlaceholder': 'अपना पूरा नाम दर्ज करें',
            'mobile': 'मोबाइल नंबर',
            'mobilePlaceholder': 'अपना मोबाइल नंबर दर्ज करें',
            'relationship': 'धर्मशाला से संबंध',
            'relationshipPlaceholder': 'अपना संबंध दर्ज करें (वैकल्पिक)',
            'statusUpdate': 'स्थिति अपडेट करें',
            'currentStatus': 'वर्तमान स्थिति',
            'newStatus': 'नई स्थिति चुनें',
            'pending': '⏳ लंबित (Pending)',
            'active': '✅ सक्रिय (Active)',
            'rejected': '❌ अस्वीकृत (Rejected)',
            'undefined': '❓ अपरिभाषित (Undefined)',
            'submitting': 'जमा हो रहा है...',
            'cancel': 'Cancel',
            'deleteConfirmation': 'Delete Confirmation',
            'areYouSure': 'Are you absolutely sure?',
            'deleteWarning': 'This action cannot be undone. This will permanently delete the dharamshala profile',
            'confirmDelete': 'Confirm delete dharamshala',
            'deleting': 'Deleting dharamshala',
            'noInnsFound': 'No inns found',
            'noInnsMessage': 'No inns have been added yet.',
            'addFirstInn': 'Add First Inn',
            'loadMoreInns': 'Load More Inns',
            // Priest-specific text
            'priestSamaj': 'मेघवाल समाज',
            'priestList': 'आचार्य गणों की सूची',
            'searchPriests': 'आचार्यों की सूची खोजें',
            'searchAndFilter': 'खोज और फ़िल्टर करें',
            'searchDescription': 'आचार्यों को नाम या कार्य पद्धति से खोजें',
            'searchByName': 'नाम से खोजें...',
            'searchByNameAria': 'नाम से आचार्य खोजें',
            'filterByWorkMethod': 'कार्य पद्धति से फिल्टर करें',
            'allWorkMethods': 'सभी कार्य पद्धति',
            'filterByStatus': 'Filter by status',
            'allStatuses': 'All Statuses',
            'searchButton': 'खोजें',
            'priestsFound': 'आचार्य मिले',
            'noPriestsAdded': 'अभी तक कोई आचार्य नहीं जोड़े गए हैं।',
            'noPriestsMatchFilter': 'कोई आचार्य वर्तमान एडमिन फ़िल्टर से मेल नहीं खाता।',
            'noApprovedPriests': 'अभी तक कोई स्वीकृत आचार्य उपलब्ध नहीं है।',
            'updatePriestInfo': 'आचार्य की जानकारी अपडेट करें',
            'newPriestInfo': 'नए आचार्य की जानकारी',
            'priestPhoto': 'आचार्य की फोटो',
            'priestName': 'आचार्य का नाम',
            'priestNamePlaceholder': 'आचार्य का नाम दर्ज करें',
            'fatherName': 'आचार्य के पिता का नाम',
            'fatherNamePlaceholder': 'आचार्य के पिता का नाम दर्ज करें',
            'addPriest': 'आचार्य जोड़ें',
            'priestAddedSuccess': 'नए आचार्य को सफलतापूर्वक जोड़ दिया गया है।'
        }
    };

    return textMap[community.name][key] || textMap['paliwal'][key] || '';
};

// Function to check if a route should be hidden for current community
export const isRouteHidden = (routeName: string): boolean => {
    const community = getCurrentCommunity();

    // Map route names to features - admin routes automatically use their parent feature
    const routeToFeatureMap: Record<string, keyof CommunityInfo['features']> = {
        'inns': 'inns',
        'inn-admin': 'inns',      // Admin route uses 'inns' feature
        'priests': 'priests',
        'priest-admin': 'priests' // Admin route uses 'priests' feature
    };

    // Get the feature name for this route
    const featureName = routeToFeatureMap[routeName];

    if (!featureName) {
        console.warn(`Unknown route: ${routeName}`);
        return false; // Default to accessible if route is not configured
    }

    // Check if the feature is enabled for the current community
    // If feature is enabled, both main and admin routes are accessible
    return !community.features[featureName];
};

// Utility functions for feature management
export const isFeatureEnabled = (featureName: keyof CommunityInfo['features']): boolean => {
    const community = getCurrentCommunity();
    return community.features[featureName];
};

export const getEnabledFeatures = (): (keyof CommunityInfo['features'])[] => {
    const community = getCurrentCommunity();
    return Object.entries(community.features)
        .filter(([_, enabled]) => enabled)
        .map(([feature]) => feature as keyof CommunityInfo['features']);
};

export const getDisabledFeatures = (): (keyof CommunityInfo['features'])[] => {
    const community = getCurrentCommunity();
    return Object.entries(community.features)
        .filter(([_, enabled]) => !enabled)
        .map(([feature]) => feature as keyof CommunityInfo['features']);
};

// Function to get Firebase configuration for current community
export const getFirebaseConfig = () => {
    const community = getCurrentCommunity();
    return community.firebase;
};

// Function to get Firebase project ID for current community
export const getFirebaseProjectId = (): string => {
    const community = getCurrentCommunity();
    return community.firebase.projectId;
};

// Function to get Firebase storage bucket for current community
export const getFirebaseStorageBucket = (): string => {
    const community = getCurrentCommunity();
    return community.firebase.storageBucket;
};

// Function to check if Firebase needs to be reinitialized for a different community
export const shouldReinitializeFirebase = (currentProjectId: string): boolean => {
    const community = getCurrentCommunity();
    return currentProjectId !== community.firebase.projectId;
};

// Export default community for easy access
export const defaultCommunity = typeof window !== 'undefined' ? getCurrentCommunity() : COMMUNITY_CONFIG[0];
